import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../user.service';
import {
  AuthService,
  GoogleLoginProvider
} from 'angular5-social-login';
import * as AWS from 'aws-sdk';
import 'amazon-cognito-js';

// import AWS from 'aws-sdk';
// import 'amazon-cognito-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {



  constructor(private userService: UserService,  private socialAuthService: AuthService, private router: Router,
              private authService: AuthService) {

    AWS.config.region = 'us-east-1'; // Region
  }


  private AWSSync:any
  private syncClient:any

  ngOnInit() {
  }

  public socialSignIn(socialPlatform : string) {
    let socialPlatformProvider;
    if(socialPlatform == "google"){
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }

    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        this.userService.fullname = userData.name;
        var ic1 = userData.email.split('@')[1]
        this.userService.user.email = userData.email;
        this.userService.user.img = userData.image;
        this.userService.user.name = userData.name;
        this.userService.user.gmailid = userData.id;


        console.log(userData.idToken , "TOKEN!!!")
        AWS.config.logger = console;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'us-east-1:9b18595b-d44a-4009-8324-8dadaeeaa75c',
          Logins: {
            'accounts.google.com': userData.idToken
          }
        });

	// if (ic1 == 'ic-1.com') {
       if (ic1 != "true" ) {
          let that = this;
          AWS.config.getCredentials(function (err) {
            that.AWSSync = AWS
            that.syncClient = new that.AWSSync.CognitoSyncManager()
            console.log('ERROR1:', err)
            that.syncClient.openOrCreateDataset('googleid', function (err2, dataset) {
              dataset.put('gid', userData.id, function (err3, record) {
                console.log('inside  put')

                console.log('ERROR', err3);
                dataset.synchronize({

                  onSuccess: function (data, newRecords) {
                    if (err) console.log(err.stack); // credentials not loaded
                    else {
                      that.userService.cognitoAccessKey = AWS.config.credentials.accessKeyId;
                      that.userService.cognitoSecretKey = AWS.config.credentials.secretAccessKey;
                      that.userService.cognitoSessionToken = AWS.config.credentials.sessionToken;
                      that.router.navigate(['/userprofile']);
                    }
                  }

                });
              });
            });
          });
        } else {
          console.log("Access Denied only ic-1 employees");
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts